<template>
    <div class="information">
        <div class="description" v-html="location.short_description"></div>

        <nav class="navigation">
            <ul>
                <li>
                    <button v-on:click.prevent.stop="openModal('description')" type="button">
                        <svg-icon name="description"></svg-icon>
                        {{ trans.seat.media.description }}
                    </button>
                </li>
                <li>
                    <button v-on:click.prevent.stop="openModal('maps')" type="button">
                        <svg-icon name="map"></svg-icon>
                        {{ trans.seat.media.map }}
                    </button>
                </li>
                <li>
                    <button v-on:click.prevent.stop="openModal('photos')" type="button">
                        <svg-icon name="images"></svg-icon>
                        {{ trans.seat.media.images }}
                    </button>
                </li>
                <li>
                    <button v-on:click.prevent.stop="openModal('videos')" type="button">
                        <svg-icon name="video"></svg-icon>
                        {{ trans.seat.media.video }}
                    </button>
                </li>
            </ul>
        </nav>

        <modal name="simple">
            <h2 slot="header" v-html="location.name"></h2>
            <div slot="body" v-if="location.modal">
                <div v-if="location.modal.type === 'loading'">
                    <div class="loading">
                        <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-if="['description', 'error'].includes(location.modal.type)" v-html="location.modal.content"></div>
                <div v-if="['photos', 'maps'].includes(location.modal.type)" class="slide">
                    <tiny-slider :mouse-drag="true" items="1" gutter="12">
                        <figure v-for="(image, i) in location.modal.content" v-bind:key="i" class="item">
                            <img v-bind:src="image.src" alt="" />
                        </figure>
                    </tiny-slider>
                </div>
                <div v-if="location.modal.type === 'videos'" class="slide">
                    <tiny-slider :mouse-drag="true" items="1" gutter="12">
                        <video-responsive v-for="(video, i) in location.modal.content" v-bind:key="i" :id="video.src"></video-responsive>
                    </tiny-slider>
                </div>
            </div>
        </modal>
    </div>
</template>

<style lang="scss" scoped>
    .information {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .description {
        width: 55%;
        max-width: 650px;
        font-size: 17px;
        color: var(--color-gray-dark-content);

        p {
            margin: 0;
        }
    }

    .navigation {
        width: 35%;
        max-width: 360px;

        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            list-style: none;
            margin: 0;
            padding: 0;
        }

        li {
            width: 48%;
            margin-bottom: 20px;
        }

        button {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--color-gray-dark-content);
            border: 1px solid var(--color-gray-content);
            border-radius: 1em;
            font-size: 16px;
            padding: 0 12px 0 32px;
            height: 30px;
            width: 100%;
        }

        .icon-wrap {
            display: flex;
            height: 17px;
            width: 17px;
            margin-right: 12px;
        }
    }
</style>

<style lang="scss">
    .navigation .icon-wrap svg,
    .navigation .icon-wrap.icon {
        width: 100%;
        height: 100%;
        transform: scale(0.8) translate(10%, 10%);
    }
</style>

<script>
    import axios from 'axios'
    import TinySlider from 'tiny-slider'
    import SvgIcon from '../general/SvgIcon.vue'
    import Modal from '../modal/ModalWrapper.vue'
    import VideoResponsive from '../general/VideoResponsive.vue'

    export default {
        props: ['location', 'trans'],
        props: {
            location: {
                type: Object,
                required: true,
            },
            trans: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                modal: {
                    show: false,
                },
            }
        },

        components: {
            SvgIcon, Modal
        },

        methods: {
            setupContent(type, content) {
                this.$root.toggleModal()

                const types = ['maps', 'photos', 'description', 'videos']

                if (types.includes(type)) {
                    this.location.modal = {
                        type,
                        content: content[type]
                    }

                    this.$root.toggleModal()
                    return content[type]
                }

                this.$root.toggleModal()
                this.location.modal = { type, content }
                return null
            },
            openModal(type) {
                this.$root.toggleModal()
                this.location.modal = {
                    type: 'loading'
                }

                const slug = this.location.slug
                const url = '/api/'
                const method = 'get'
                const response = axios.get(url, {
                    method,
                    params: {
                        path: `tickets/locations/${slug}`
                    },
                })

                response.then(response => {
                    return this.setupContent(type, response.data);
                })
                .catch(error => {
                    return this.setupContent('error', 'An error has ocurred.');
                })
            },
        }
    }
</script>
